import * as React from 'react';
import { ReactNode } from 'react';
import '../css/instructions-panel.sass';

interface InstructionsPanelProps {
  primaryText: string;
  children: ReactNode;
}

interface InstructionsPanelState {
  collapsed: boolean;
}

export default function InstructionsPanel(props: InstructionsPanelProps) {
  const [state, setState] = React.useState<InstructionsPanelState>({
    collapsed: true
  });

  const handleCollapse = () => {
    setState({ collapsed: !state.collapsed });
  };

  const handleKeyDown = (e: any) => {
    if (e.keyCode === 13 || e.keyCode === 32) {
      setState({ collapsed: !state.collapsed });
    }
  };

  return (
    <div className="instructions">
      <div
        className="primary-text"
        onClick={handleCollapse}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
      >
        {props.primaryText}

        <span
          className={state.collapsed ? `arrow-up` : `arrow-down`}
          onClick={handleCollapse}
          role="presentation"
        ></span>
      </div>

      {!state.collapsed && props.children}
    </div>
  );
}
